<template>
  <v-form v-model="form_validate_status" ref="form" :loading="loading">
    <v-card max-width="750" class="mx-auto" color="grey-lighten-3">
      <v-layout>
        <CustomAppBar :page="3" :title="$t('info_card.title_page3')" />
        <v-main
          ><v-card-text
            ><h3>{{ $t("info_card.university_location") }}</h3>
            <div class="pt-3">
              <v-radio-group
                v-model="universityLocation"
                :mandatory="false"
                row
                v-bind:rules="requiredRules"
              >
                <v-row>
                  <v-col cols="12" sm="4">
                    <v-radio
                      v-bind:label="$t('info_card.in_thai')"
                      value="inThai"
                    ></v-radio>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-radio
                      v-bind:label="$t('info_card.foreign_country')"
                      value="foreignCountry"
                    ></v-radio>
                  </v-col>
                </v-row>
              </v-radio-group>
              <v-row v-if="universityLocation === 'inThai'"
                ><v-col cols="12" sm="6"
                  ><h6>{{ $t("info_card.province") }}</h6>
                  <v-autocomplete
                    variant="outlined"
                    density="compact"
                    v-model="province_id"
                    v-bind:rules="requiredRules"
                    v-bind:items="provinces"
                    v-bind:item-title="
                      (item) => objectTranslator(item, 'PROVINCE_NAME')
                    "
                    v-bind:item-value="(item) => item.PROVINCE_ID"
                    @update:modelValue="update_province"
                  ></v-autocomplete></v-col
                ><v-col cols="12" sm="6"
                  ><h6>{{ $t("info_card.university_name") }}</h6>
                  <v-autocomplete
                    variant="outlined"
                    density="compact"
                    v-model="university_id"
                    v-bind:rules="requiredRules"
                    v-bind:items="filteredUniversitys"
                    v-bind:item-title="
                      (item) => objectTranslator(item, 'UNIVERSITY_NAME')
                    "
                    v-bind:item-value="(item) => item.UNIVERSITY_ID"
                  ></v-autocomplete>
                  <p v-html="$t('info_card.page32_text')"></p>
                  </v-col
              ></v-row>
              <v-row v-if="universityLocation === 'foreignCountry'"
                ><v-col cols="12" sm="6"
                  ><h6>{{ $t("info_card.country") }}</h6>
                  <v-autocomplete
                    variant="outlined"
                    density="compact"
                    v-model="nation_id"
                    v-bind:rules="requiredRules"
                    v-bind:items="nations"
                    v-bind:item-title="
                      (item) => objectTranslator(item, 'NATION_NAME')
                    "
                    v-bind:item-value="(item) => item.NATION_ID"
                  ></v-autocomplete></v-col
                ><v-col cols="12" sm="6"
                  ><h6>{{ $t("info_card.university_name") }}</h6>
                  <v-text-field
                    variant="outlined"
                    density="compact"
                    v-model="university_name"
                    v-bind:rules="requiredRules"
                    v-bind:label="textLabelSurnameTh"
                    v-bind:placeholder="textHintSurnameTh"
                  ></v-text-field></v-col
              ></v-row>
            </div> </v-card-text
          ><v-divider></v-divider>
          <v-card-text
            ><FacultyCurriculum v-model="faculty_curriculum" />
            <v-row
              ><v-col cols="12" sm="6"
                ><h6>{{ $t("info_card.graduated_year") }}</h6>
                <GraduateYear v-model="graduated_year" /></v-col
              ><v-col cols="12" sm="6"
                ><h6>GPA</h6>
                <GPACard v-model="gpa" /></v-col></v-row></v-card-text
          ><v-divider></v-divider>
          <v-card-text
            ><div
              class="text-end mb-2 text-red"
              v-if="is_saved_before_page === false"
            >
              {{ $t("info.have_not_fill_page_before") }}
            </div>
            <div class="text-end">
              <v-btn color="primary" size="large" class="mr-2" to="/page2"
                >Back</v-btn
              >
              <v-btn
                color="primary"
                size="large"
                :disabled="is_saved_before_page === false"
                @click="saveData"
                >{{ is_lock_kmitl1 === true ? "Next" : "Save & Next" }}</v-btn
              >
            </div>
          </v-card-text>
        </v-main>
      </v-layout>
    </v-card>
  </v-form>
</template>

<script>
import CustomAppBar from "@/components/info_cards/CustomAppBar.vue";
import FacultyCurriculum from "@/components/info_cards/FacultyCurriculum.vue";
import GraduateYear from "@/components/info_cards/GraduateYear.vue";
import GPACard from "@/components/info_cards/GPACard.vue";
import validator from "@/helper/validator";

import { objectTranslator } from "@/helper/translator";
import { getById } from "@/helper/filter";
import PageProvider from "@/services/page.provider";
const pageService = new PageProvider();
export default {
  name: "PageThreeTwo",
  components: {
    CustomAppBar,
    FacultyCurriculum,
    GraduateYear,
    GPACard,
  },
  data: () => ({
    requiredRules: [validator.required],
    form_validate_status: false,
    loading: false,
    is_lock_kmitl1: true,
    is_saved_before_page: false,

    // thaiOrForeignUniversity: {
    universityLocation: null,
    province_id: null,
    university_id: null,
    nation_id: null,
    university_name: null,
    // },
    faculty_curriculum: { faculty_name: null, curriculum_name: null },
    gpa: null,
    graduated_year: null,
  }),
  methods: {
    getById,
    objectTranslator,
    update_province() {
      this.university_id = null;
    },

    async getData() {
      this.loading = true;
      this.is_lock_kmitl1 =
        this.surrogated_student_info.LOCK_KMITL1 == "0" ? false : true;

      const data = await pageService.getPage3_2(this.uid).catch((error) => {
        this.$toast.error(JSON.stringify(error.response.data.message));
      });
      if (data.length === 0) {
        this.universityLocation = "inThai";
      } else {
        if (data.EDUCATION_NATION === "TH") {
          this.universityLocation = "inThai";
          this.university_id = data.UNIVERSITY_ID;
          this.province_id = data.UNIVERSITY_PROVINCE_CODE;
        } else {
          this.universityLocation = "foreignCountry";
          this.university_name = data.UNIVERSITY_NAME;
        }
      }
      this.nation_id = data.EDUCATION_NATION;
      this.faculty_curriculum.faculty_name = data.FACULTY_NAME;
      this.faculty_curriculum.curriculum_name = data.CURRICULUM_NAME;
      this.gpa = data.GPA;
      this.graduated_year = data.YEAR;
      this.loading = false;
    },

    async saveData() {
      if (this.form_validate_status === true) {
        if (this.is_lock_kmitl1 === false) {
          this.loading = true;
          if (this.universityLocation === "inThai") {
            this.education_nation = "TH";
            this.university_name = null;
          } else {
            this.education_nation = this.nation_id;
          }
          const response = await pageService
            .setPage3_2({
              uid: this.uid,
              FACULTY_NAME: this.faculty_curriculum.faculty_name ?? null,
              CURRICULUM_NAME: this.faculty_curriculum.curriculum_name ?? null,
              YEAR: this.graduated_year ?? null,
              GPA: this.gpa ?? null,

              EDUCATION_NATION: this.education_nation ?? null,
              UNIVERSITY_ID:
                this.education_nation == "TH" ? this.university_id : null,
              UNIVERSITY_NAME: this.university_name ?? null,
            })
            .catch((error) => {
              this.$toast.error(JSON.stringify(error.response.data.message));
              this.loading = false;
            });
          if (response && response.status) {
            this.$toast.success(this.$t("toast.save_successfully"));
            this.$router.push("/page4");
          } else this.$toast.error(this.$t("toast.cannot_save"));
          this.loading = false;
        } else {
          this.$router.push("/page4");
        }
      } else {
        this.$toast.error(this.$t("toast.cannot_save"));
      }
    },
  },

  computed: {
    uid() {
      return this.$store.state.user.surrogated_student_uid;
    },

    surrogated_student_info() {
      return this.$store.state.user.surrogated_student_info;
    },

    provinces() {
      return this.$store.state.ref.provinces;
    },
    nations() {
      return this.$store.state.ref.nations;
    },
    universitys() {
      return this.$store.state.ref.universitys;
    },

    filteredUniversitys() {
      let data = this.universitys;
      if (this.province_id) {
        data = data.filter(
          (item) => this.province_id === item.UNIVERSITY_PROVINCE_CODE
        );
      }
      return data;
    },
  },
  async created() {
    await this.$store.dispatch("user/getUserInfo");
    this.is_saved_before_page =
      this.surrogated_student_info.ENTERED.includes("2");
    if (this.is_saved_before_page === false) {
      this.$router.push("/main");
    }

    this.$store.dispatch("ref/getProvinces");
    this.$store.dispatch("ref/getUniversitys");
    this.$store.dispatch("ref/getNations");

    this.getData();
  },
};
</script>
<style scoped></style>
